var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoader = function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 100 100"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-idx": 0
  }, /*#__PURE__*/React.createElement("defs", {
    "data-idx": 2
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "loader_svg__a",
    "data-idx": 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.4 35.975a4.5 4.5 0 0 1-3.832-8.143 24.5 24.5 0 1 1-11.736 32.6 4.5 4.5 0 0 1 8.143-3.832A15.5 15.5 0 1 0 43.4 35.975",
    "data-idx": 4
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#loader_svg__a)",
    "data-idx": 6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f49202",
    d: "M20.5 0h12.6v100H20.5z",
    "data-idx": 7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe2b46",
    d: "M32.1 0h12.6v100H32.1z",
    "data-idx": 9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7ee0fe",
    d: "M43.7 0h12.6v100H43.7z",
    "data-idx": 11
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7ee0fe",
    d: "M55.3 0h12.6v100H55.3z",
    "data-idx": 13
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#22cb26",
    d: "M66.9 0h12.6v100H66.9z",
    "data-idx": 15
  })))));
};
export default SvgLoader;